import React, {useState} from 'react';
import {monthDays} from "../../../../components/functions/Month";
import {NavLink} from "react-router-dom";
import {ArrowLeftOutlined, SaveOutlined} from '@ant-design/icons'
import axios from "axios";
import {header} from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";

function Edit({month, data,setData}) {
    const [changet,setChanged] = useState(false)
    const changeData = (index,kun,val) => {
        let cd = [...data]
        if(cd[index]){
            if(cd[index].data){
                cd[index].data[kun] = val
                setChanged(true)
            }
        }
        setData(cd)
    }
    const saveHandler = () => {
        const save = async () => {
            const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/district/wateruse/save",
                {
                    month,
                    data,
                },
                header())
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                alert(res.data.message)
                console.log(res.data)
            }
        }
        save()
    }
    return (
        <div className="table-box-con">
            <div className="table-content-top">
                <div className="table-top-left d-flex">
                    <NavLink to="/suvdanfoydalanish/" className="btn btn-warning d-flex align-items-center p-2 btn-sm"><ArrowLeftOutlined />&nbsp;Qaytish</NavLink>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <button onClick={saveHandler} disabled={changet?false:true} className="btn btn-success d-flex align-items-center p-2 btn-sm">Saqlash&nbsp;<SaveOutlined /></button>
                </div>
            </div>
            <div className="table-responsive">
                <div style={{width:'100%'}}>
                    <table id="tblData" className="table table-bordered table-style">
                        <thead>
                        <tr>
                            <th rowSpan={2} scope="col">№</th>
                            <th rowSpan={2} scope="col">Manba nomi</th>
                            <th colSpan={monthDays(month)} scope="col">{month}</th>
                        </tr>
                        <tr>
                            {
                                Array(monthDays(month)).fill(1).map((i,d)=>{
                                    return <th key={d}>{d+1}</th>
                                })
                            }
                        </tr>
                        </thead>
                        {
                            data.length?
                                data.map((d,i)=>{
                                    return(
                                        <tbody key={i+"d"}>
                                        <tr>
                                            <td>{i+1}</td>
                                            <td className="text-start">{d.name}</td>
                                            {
                                                Array(monthDays(month)).fill(1).map((k,ind)=>{
                                                    return <td key={ind+'da'} className="inserttr">
                                                        <input
                                                            type="number"
                                                            className="insertable"
                                                            value={d.data?d.data[ind+1]?d.data[ind+1]:'':''}
                                                            onChange={e=>changeData(i,ind+1,e.target.value)}
                                                        />
                                                    </td>
                                                })
                                            }
                                        </tr>
                                        </tbody>
                                    )
                                })
                                :null
                        }
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Edit;